module.exports = __webpack_public_path__ + "img/gris-7.6626d4b5.png";